import Helper from '../helpers/Helper';

export default class Certifications {
    static init() {
        this.hideNotValidItems();
    }
    static hideNotValidItems() {
        let certificationInHeader = document.querySelector('.header-stamp'),
            certificationItems = document.querySelectorAll('.certifications__list-item'),
            certificationsInFooter = document.querySelectorAll('.footer__stamp-item');

        if (certificationInHeader !== null) {
            if (certificationInHeader.hasAttribute('data-valid-until')) {
                this.checkValidity(certificationInHeader);
            } else {
                this.showItem(certificationInHeader);
            }
        }
        if (certificationItems !== null) {
            certificationItems.forEach((el__value) => {
                if (el__value.hasAttribute('data-valid-until')) {
                    this.checkValidity(el__value);
                } else {
                    this.showItem(el__value);
                }
            });
        }
        if (certificationsInFooter !== null) {
            certificationsInFooter.forEach((el__value) => {
                el__value.classList.remove('hide-item');
                if (el__value.hasAttribute('data-valid-until')) {
                    this.checkValidity(el__value);
                } else {
                    this.showItem(el__value);
                }
            });
        }
    }
    static showItem(el) {
        if (el.classList.contains('hide-item')) {
            el.classList.remove('hide-item');
        }
    }
    static hideItem(el) {
        el.classList.add('hide-item');
    }
    static removeItem(el) {
        el.remove();
    }
    static checkValidity(el) {
        let valid_until = new Date(el.getAttribute('data-valid-until')),
            now = new Date();
        valid_until.setHours(0);
        valid_until.setMinutes(0);
        valid_until.setSeconds(0);
        valid_until.setMilliseconds(0);
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);
        now.setMilliseconds(0);

        if (now > valid_until) {
            if (!Helper.isInsideEditor()) {
                this.removeItem(el);
            }
            if (Helper.isInsideEditor()) {
                this.hideItem(el);
            }
        } else {
            if (Helper.isInsideEditor()) {
                this.showItem(el);
            }
        }
    }
}
